class TourCardCarousel {
    constructor(containerSelector, slideSelector, threshold = 1) {
        this.$container = $(containerSelector);
        this.$slides = this.$container.find(slideSelector);
        this.currentIndex = 0;
        this.observer = new IntersectionObserver(
          (entries) => this.handleIntersect(entries),
          {
            root: this.$container.get(0),
            threshold: threshold,
          }
        );

        this.observeSlides();
        this.attachClickHandlers(); // click handlers for dimmed slides
    }

    handleIntersect(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                this.$slides.removeClass('active');
                $(entry.target).addClass('active');
                let tmProductId = $(entry.target).attr('data-tm-product-id') ?? '';
                let blogProductId = $(entry.target).attr('data-blog-product-id') ?? '';
                jQuery(document).trigger('triggerTourCardCarouselChange', {tmProductId: tmProductId, blogProductId: blogProductId});
                this.currentIndex = this.$slides.index(entry.target);
            }
        });
    }

    observeSlides() {
        this.$slides.each((_, slide) => {
            this.observer.observe(slide);
        });
    }

    attachClickHandlers() {
        this.$slides.on('click', (e) => {
            const clickedIndex = this.$slides.index(e.currentTarget);

            // Left dimmed slide clicked
            if (clickedIndex === this.currentIndex - 1 || (this.currentIndex === 0 && clickedIndex === this.$slides.length - 1)) {
                this.scrollToSlide(this.currentIndex === 0 ? this.$slides.length - 1 : this.currentIndex - 1);
            }

            // Right dimmed slide clicked
            else if (clickedIndex === this.currentIndex + 1 || (this.currentIndex === this.$slides.length - 1 && clickedIndex === 0)) {
                this.scrollToSlide(this.currentIndex === this.$slides.length - 1 ? 0 : this.currentIndex + 1);
            }
        });
    }

    scrollToSlide(index) {
        if (index >= 0 && index < this.$slides.length) {
            const $targetSlide = this.$slides.eq(index);
            this.$container.animate(
                {
                    scrollLeft: $targetSlide.position().left + this.$container.scrollLeft()
                },
                100
            );
        }
    }
}
